<template>
  <div id="terminal-cont" class="terminal-cont">
    <div id="terminal" class="terminal">
      <p><span class="term-dollar">$</span>Hello World</p>

      <p class="finding-new">
        Finding new ways to discover art through technology has always been
        fascinating to me. After nearly a decade of exploring, experimenting and
        learning about all kinds of different technologies, I’ve found a passion
        in using them to create visually exciting products and experiences.
      </p>

      <p class="wecolome-to-site"><span class="term-dollar">$</span></p>
      <vue-typer
        class="welcome-type"
        :text="['Welcome to my site! ']"
        :repeat="Infinity"
        :shuffle="false"
        initial-action="typing"
        :pre-type-delay="43"
        :type-delay="100"
        :pre-erase-delay="5000"
        :erase-delay="50"
        erase-style="select-back"
        :erase-on-complete="false"
        caret-animation="blink"
      >
      </vue-typer>
    </div>
  </div>
</template>

<script>
import { VueTyper } from "vue-typer";

var MyComponent = {
  components: {
    VueTyper,
  },
};

export default {};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Fira+Sans:300");
@import "../scss/styles.scss";
.terminal-cont {
  width: 100%;
  max-width: 800px;
  min-height: 470px;
  margin: auto;
  overflow: hidden;
  font-family: "Fira Sans", sans-serif;
  font-size: 20px;
  position: relative;
  @include md {
    min-height: 380px;
  }

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }
  .terminal,
  .terminal:before,
  .terminal:after,
  p:after {
    position: absolute;
  }
  .terminal {
    width: 90%;
    margin: 1rem;
    padding: 26px 4px 4px;
    border-radius: 5px;
    background: linear-gradient(
      #f6f6f6,
      #d3d3d3 20px,
      #7e7e7e 20px,
      #7e7e7e 21px,
      #393456 21px
    );
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
    transition: all 0.5s ease;
    @include sm {
      width: 95%;
    }
  }
  .terminal:before {
    content: " ";
    width: 10px;
    height: 10px;
    margin: -20px 0 0 5px;
    border-radius: 5px;
    background: #fc625d;
    box-shadow: 0 0 0 1px #de413e, 15px 0 #fec041, 15px 0 0 1px #dda035,
      30px 0 #35cc4b, 30px 0 0 1px #28aa36;
  }
  .terminal-cont:after {
    width: 100%;
    content: "-zsh";
    top: 0;
    text-align: center;
    color: #4c4c4c;
    line-height: 20px;
  }
  p {
    color: #fff;
    margin-left: 0.2rem;
    max-width: 98%;
    &:first-of-type {
      margin: 1.2rem 0 0.8rem 0.2rem;
    }
    span.term-dollar {
      opacity: 0.5;
      margin-right: 8px;
    }
  }

  .wecolome-to-site {
    display: inline-block;
  }
}

.welcome-type {
  display: inline-block;
  span.left span {
    color: $white;
    // &:after {
    //   -webkit-animation: blink 1s linear 1s infinite;
    //   animation: blink 1s linear 1s infinite;
    //   content: " ";
    //   width: 8px;
    //   height: 18px;
    //   margin-left: 1px;
    //   margin-top: 6px;
    //   background: #fec041;
    // }
  }
  .custom.caret {
    background-color: #fec041 !important;
    width: 6px;
    font-size: 14px;
    margin-left: 1px;
    height: 16px;
  }
}

.finding-new {
  padding-left: 18px;
  position: relative;
  &::before {
    content: "$";
    opacity: 0.5;
    position: absolute;
    left: 0;
  }
}
</style>